// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"GanttChart_chartWrapper__1Rt0G","ownerName":"GanttChart_ownerName__3n8Io","chartValues":"GanttChart_chartValues__2yk2-","chartBars":"GanttChart_chartBars__pnm8A"};